import React from 'react';
import styled from 'styled-components';
import { useConfig } from '../../hooks';
import { isUnpublishedEntry, isUnpublishedAsset } from './view-model-error.types';
import * as Sentry from '@sentry/react';
export function ViewModelError({ model }) {
    if (isUnpublishedEntry(model) || isUnpublishedAsset(model)) {
        Sentry.captureException(new Error('View Model Error'), {
            tags: {
                team: 'bxpt',
                modelType: model.sys.linkType,
                contentId: model.sys.id
            }
        });
    }
    const { environment } = useConfig();
    if (environment === 'production') {
        return null;
    }
    const goToUrl = `https://app.contentful.com/spaces/rz1oowkt5gyp/environments/${environment}`;
    return (React.createElement(WarningBlock, null,
        isUnpublishedEntry(model) && (React.createElement(React.Fragment, null,
            React.createElement(WarningText, null,
                "There is an unpublished ",
                React.createElement("b", null, "entry"),
                " here."),
            React.createElement(WarningLink, { href: `${goToUrl}/entries/${model.sys.id}` },
                "Go to entry ID: ",
                model.sys.id))),
        isUnpublishedAsset(model) && (React.createElement(React.Fragment, null,
            React.createElement(WarningText, null,
                "There is an unpublished ",
                React.createElement("b", null, "asset"),
                " here."),
            React.createElement(WarningLink, { href: `${goToUrl}/assets/${model.sys.id}` },
                "Go to asset ID: ",
                model.sys.id)))));
}
const WarningBlock = styled.div `
  background-color: transparent;
  color: inherit;
  border-radius: 0.75rem;
  padding: 0.75rem 1.5rem;
  margin-bottom: 1rem !important;
  border: 2px dashed #de350b;
`;
const WarningText = styled.div `
  font-size: 1.25rem;
`;
const WarningLink = styled.a `
  font-size: 1rem;
  text-underline-offset: 0.25rem;
`;
//# sourceMappingURL=ViewModelError.js.map